import { FC, useCallback } from 'react'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { cleanupSubscriptionMessagesActionCreator } from 'actions/subscriptionActions'
import { subscriptionSelector } from 'selectors/subscriptionSelectors'
import FloatingPaneNotification from 'components/features/pfm/FloatingPaneNotification/FloatingPaneNotification'
import { GENERIC_PAYMENT_ERROR } from 'constants/stripe'
import { EmailLink } from 'components/features/pfm/EmailLink/EmailLink'

type SubscriptionMessageOverlayProps = {

}

export const SubscriptionMessageOverlay: FC<SubscriptionMessageOverlayProps> = (props) => {
  const {} = props

  const dispatch = useStoreDispatch()

  const handleClose = useCallback(() => {
    dispatch(cleanupSubscriptionMessagesActionCreator())
  }, [dispatch])

  const messages = useStoreSelector((state) => subscriptionSelector(state).messages)

  if (!messages || !messages[0]) {
    return null
  }

  const isGenericError = messages[0] === GENERIC_PAYMENT_ERROR

  return (
    <FloatingPaneNotification onDismiss={ handleClose }>
      { !isGenericError && messages[0] }
      { isGenericError && (
        <>
          Transaction failed. If you need help, contact us at:&nbsp;
          <EmailLink email='support@statusmoney.com'>support@statusmoney.com</EmailLink>
        </>
      )}
    </FloatingPaneNotification>
  )

}
